import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=2d41083d"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"
import style0 from "./Article.vue?vue&type=style&index=0&id=2d41083d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports